import React from 'react';

import { Row, Col } from 'components/layout';
import Icon from 'components/Icon';

import Feedback from '../Feedback';
import { labelsByVariant } from 'views/Btc/constants';

const WaitingToStartView = ({ variant }) => (
  <Row justify="center" align="middle" style={{ height: '100%' }}>
    <Col style={{ textAlign: 'center' }}>
      <Feedback
        title={labelsByVariant[variant].waitingStartTitle}
        message={labelsByVariant[variant].waitingStartDescription}
        img={<Icon name="clock" color={variant === 'v2' ? "#B9C2C9" : "#FADB14"}  />}
      />
    </Col>
  </Row>
);

export default WaitingToStartView;